<div class="status-processing-container" *ngIf="mostrar">
  <div class="status-processing-card">
    <div class="status-processing-content">
      <div class="status-processing-icon">
        <div class="pulse-ring"></div>
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
      <ng-content></ng-content>
      <ng-container *ngIf="titulo || subtitulo">
        <h4 class="status-processing-title mb-1 text-center">
          <strong>{{ titulo }}</strong>
        </h4>
        <h3 class="status-processing-title">{{ subtitulo }}</h3>
      </ng-container>
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
      </div>
    </div>
  </div>
</div>
